import Tools from '@/components/tools/Tools'
import AccountRepository from '@/shared/http/repositories/access/account'
import AccountContractsRepository from '@/shared/http/repositories/business/accountcontracts'
import CompanyPciDocsRepository from '@/shared/http/repositories/pci/companyPciDocs'
import ContractsRepository from '@/shared/http/repositories/pci/contract'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'

export default {
  name: 'ContractsAccess',
  mixins: [CompanyMixin],
  data () {
    return {
      users: [],
      availableUsers: {
        options: [],
        visibleOptions: [],
        values: []
      },
      selectedUsers: {
        options: [],
        visibleOptions: [],
        values: []
      },
      selectedUser: null,
      selectedUserName: null,
      selectedContract: null,
      selectedUserCopy: '',
      keyWord: '',
      keyWordSelected: '',
      keyFilter: {
        name: '',
        date: ''
      },
      contracts: [],
      contractsAdded: [],
      contractsRemoved: [],
      availableContracts: {
        options: [],
        visibleOptions: [],
        values: []
      },
      selectedContracts: {
        options: [],
        visibleOptions: [],
        values: []
      },
      copyType: 'inclusive',
      copyToUsers: []
    }
  },
  beforeMount () {
    Tools.MinimizedSidebar()
    loading.push()

    // Get accounts
    AccountRepository.GetAll()
      .then(response => {
        // Verifies response status
        if (response.data.code > 0) {
          // Stores only relevant data
          this.users = response.data.data.filter(ac => ac.grupo.nome !== 'ADMINISTRADORES').map(account => ({
            value: account.id,
            text: account.nome + ' (' + account.username + ')',
            group: account.grupo.nome
          }))
        }
      })
      .catch(err => {
        toast.error(this.$lang.Common.CouldNotLoadRegister)
        console.log(err)
      })
      .finally(() => loading.close())

    ContractsRepository.GetAll(this.company.id)
      .then(response => {
        // Verifies response status code
        if (response.data.code > 0) {
          // Stores only relevant data to render in grid
          this.contracts = response.data.data
            .map(contract => {
              return {
                id: contract.contratoID,
                name: contract.descricao,
                show: true
              }
            })
        } else {
          toast.error(this.$lang.Common.CouldNotLoadRegister)
        }
      })
      .catch(error => {
        console.log(error)
        toast.error(this.$lang.Common.CouldNotLoadRegister)
      })
      .finally(() => {
        loading.close()
      })
  },
  methods: {
    onSelectUser () {
      this.selectedContract = null

      this.selectedContracts.options = []
      this.selectedContracts.visibleOptions = []
      this.availableContracts.options = []
      this.availableContracts.visibleOptions = []

      this.selectedUsers.options = []
      this.selectedUsers.visibleOptions = []
      this.availableUsers.options = []
      this.availableUsers.visibleOptions = []

      this.contractsAdded = []
      this.contractsRemoved = []

      this.selectedUserName = null

      if (this.selectedUser) {
        loading.push()
        this.selectedUserName = this.users.find(x => x.value === this.selectedUser).text

        AccountContractsRepository.GetByAccount(this.company.id, this.selectedUser)
          .then(response => {
            if (response.status !== 200) {
              loading.close()
              toast.error(this.$lang.Common.CouldNotLoadRegister)
              return
            }

            // Loop received data
            this.contracts.forEach(contract => {
              const option = {value: contract.id, text: contract.name}
              if (response.data.data.some(ct => ct.contrato.id === contract.id)) {
                this.selectedContracts.options.push(option)
              } else {
                this.availableContracts.options.push(option)
              }
            })

            this.availableContracts.options = this.availableContracts.options.sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
            this.selectedContracts.options = this.selectedContracts.options.sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)

            this.processVisibleAvailableContracts(this.keyWord)
            this.processVisibleSelectedContracts(this.keyWordSelected)

            loading.close()
          })
          .catch(err => {
            console.log(err)
            toast.error(this.$lang.Common.Alerts.Error)
          })
      }
    },
    onSelectContract () {
      this.selectedUser = null

      this.selectedContracts.options = []
      this.selectedContracts.visibleOptions = []
      this.availableContracts.options = []
      this.availableContracts.visibleOptions = []

      this.selectedUsers.options = []
      this.selectedUsers.visibleOptions = []
      this.availableUsers.options = []
      this.availableUsers.visibleOptions = []

      this.contractsAdded = [this.selectedContract]
      this.contractsRemoved = []

      if (this.selectedContract) {
        loading.push()

        AccountContractsRepository.GetByContract(this.company.id, this.selectedContract)
          .then(response => {
            if (response.status !== 200) {
              loading.close()
              toast.error(this.$lang.Common.CouldNotLoadRegister)
              return
            }

            this.selectedUsers.options = response.data.data.map(user => {
              return {value: user.conta.id, text: user.conta.nome}
            })
            this.availableUsers.options = this.users.filter(ct => !this.selectedUsers.options.some(sct => sct.value === ct.value)).map(usr => {
              return {value: usr.value, text: usr.text}
            })

            this.availableUsers.options = this.availableUsers.options.sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
            this.selectedUsers.options = this.selectedUsers.options.sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)

            this.processVisibleAvailableUsers(this.keyWord)
            this.processVisibleSelectedUsers(this.keyWordSelected)

            loading.close()
          })
          .catch(err => {
            console.log(err)
            toast.error(this.$lang.Common.Alerts.Error)
          })
      }
    },
    addContracts () {
      this.contractsAdded = this.contractsAdded.concat(this.availableContracts.values.filter(vl => !this.contractsRemoved.includes(vl)))
      this.contractsRemoved = this.contractsRemoved.filter(cr => !this.availableContracts.values.includes(cr))
      this.selectedContracts.options = this.selectedContracts.options.concat(
        this.contracts
          .filter(c => this.availableContracts.values.includes(c.id))
          .map(m => { return { value: m.id, text: m.name } })
      ).sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      this.availableContracts.options = this.availableContracts.options.filter(c => !this.availableContracts.values.includes(c.value))
      this.processVisibleAvailableContracts(this.keyWord)
      this.processVisibleSelectedContracts(this.keyWordSelected)
    },
    addUsers () {
      this.selectedUsers.options = this.selectedUsers.options.concat(
        this.users
          .filter(c => this.availableUsers.values.includes(c.value))
          .map(m => { return { value: m.value, text: m.text } })
      ).sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      this.availableUsers.options = this.availableUsers.options.filter(c => !this.availableUsers.values.includes(c.value))
      this.processVisibleAvailableUsers(this.keyWord)
      this.processVisibleSelectedUsers(this.keyWordSelected)
    },
    addAllContracts () {
      this.contractsAdded = this.contractsAdded.concat(this.availableContracts.visibleOptions.filter(acv => !this.contractsRemoved.includes(acv.value)).map(acv => acv.value))
      this.contractsRemoved = this.contractsRemoved.filter(cr => !this.availableContracts.visibleOptions.some(acv => acv.value === cr))
      this.selectedContracts.options = this.selectedContracts.options.concat(
        [...this.availableContracts.visibleOptions]
      ).sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      this.availableContracts.options = this.availableContracts.options.filter(ac => !this.availableContracts.visibleOptions.some(acv => acv.value === ac.value))
      this.processVisibleAvailableContracts(this.keyWord)
      this.processVisibleSelectedContracts(this.keyWordSelected)
    },
    addAllUsers () {
      this.selectedUsers.options = this.selectedUsers.options.concat(
        [...this.availableUsers.visibleOptions]
      ).sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      this.availableUsers.options = this.availableUsers.options.filter(ac => !this.availableUsers.visibleOptions.some(acv => acv.value === ac.value))
      this.processVisibleAvailableUsers(this.keyWord)
      this.processVisibleSelectedUsers(this.keyWordSelected)
    },
    removeContracts () {
      this.contractsRemoved = this.contractsRemoved.concat(this.selectedContracts.values.filter(vl => !this.contractsAdded.includes(vl)))
      this.contractsAdded = this.contractsAdded.filter(ca => !this.selectedContracts.values.includes(ca))
      this.availableContracts.options = this.availableContracts.options.concat(
        this.contracts
          .filter(c => this.selectedContracts.values.includes(c.id))
          .map(m => { return { value: m.id, text: m.name } })
      ).sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      this.selectedContracts.options = this.selectedContracts.options.filter(c => !this.selectedContracts.values.includes(c.value))
      this.processVisibleAvailableContracts(this.keyWord)
      this.processVisibleSelectedContracts(this.keyWordSelected)
    },
    removeUsers () {
      this.availableUsers.options = this.availableUsers.options.concat(
        this.users
          .filter(c => this.selectedUsers.values.includes(c.value))
          .map(m => { return { value: m.id, text: m.name } })
      ).sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      this.selectedUsers.options = this.selectedUsers.options.filter(c => !this.selectedUsers.values.includes(c.value))
      this.processVisibleAvailableUsers(this.keyWord)
      this.processVisibleSelectedUsers(this.keyWordSelected)
    },
    removeAllContracts () {
      this.contractsRemoved = this.contractsRemoved.concat(this.selectedContracts.visibleOptions.filter(vl => !this.contractsAdded.includes(vl.value)).map(acv => acv.value))
      this.contractsAdded = this.contractsAdded.filter(ca => !this.selectedContracts.visibleOptions.some(scv => scv.value === ca))
      this.availableContracts.options = this.availableContracts.options.concat(
        [...this.selectedContracts.visibleOptions]
      ).sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      this.selectedContracts.options = this.selectedContracts.options.filter(sc => !this.selectedContracts.visibleOptions.some(scv => scv.value === sc.value))
      this.processVisibleAvailableContracts(this.keyWord)
      this.processVisibleSelectedContracts(this.keyWordSelected)
    },
    removeAllUsers () {
      this.availableUsers.options = this.availableUsers.options.concat(
        [...this.selectedUsers.visibleOptions]
      ).sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      this.selectedUsers.options = this.selectedUsers.options.filter(sc => !this.selectedUsers.visibleOptions.some(scv => scv.value === sc.value))
      this.processVisibleAvailableUsers(this.keyWord)
      this.processVisibleSelectedUsers(this.keyWordSelected)
    },
    saveUserAccess () {
      loading.push()
      const selectedContracts = this.selectedContracts.options.map(c => c.value)
      AccountContractsRepository.SaveAccess(this.company.id, this.selectedUser, selectedContracts)
        .then(response => {
          if (response.status !== 200) {
            loading.close()
            toast.error(this.$lang.Common.CouldNotLoadRegister)
            return
          }

          toast.success(this.$lang.Common.Alerts.Success)
          this.keyWord = ''
          this.keyWordSelected = ''
        }).catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        }).finally(() => {
          loading.close()
          this.$nextTick(() => {
            setTimeout(() => {
              const ctrs = this.contractsAdded.concat(this.contractsRemoved)
              if (ctrs.length) {
                CompanyPciDocsRepository.UpdatePermissions(this.company.id, ctrs)
                  .finally(() => {
                    this.contractsAdded = []
                    this.contractsRemoved = []
                  })
              }
            }, 1000)
          })
        })
    },
    saveContractAccess () {
      loading.push()
      const selectedUsers = this.selectedUsers.options.map(c => c.value)
      AccountContractsRepository.SaveContractAccess(this.company.id, this.selectedContract, selectedUsers)
        .then(response => {
          if (response.status !== 200) {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
            return
          }

          toast.success(this.$lang.Common.Alerts.Success)
          this.keyWord = ''
          this.keyWordSelected = ''
        }).catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        }).finally(() => {
          loading.close()
          this.$nextTick(() => {
            setTimeout(() => {
              const ctrs = this.contractsAdded.concat(this.contractsRemoved)
              if (ctrs.length) {
                CompanyPciDocsRepository.UpdatePermissions(this.company.id, ctrs)
                  .finally(() => {
                    this.contractsAdded = []
                    this.contractsRemoved = []
                  })
              }
            }, 1000)
          })
        })
    },
    showModal (id) {
      this.$bvModal.show(id)
    },
    onSelectUserCopy () {
      //
    },
    onAddUserCopy () {
      if (!this.copyToUsers.find((x) => x.value === this.selectedUserCopy)) {
        this.copyToUsers.push(this.users.find((x) => x.value === this.selectedUserCopy))
      }
    },
    removeUserCopy (id) {
      const index = this.copyToUsers.findIndex(x => x.value === id)
      this.copyToUsers.splice(index, 1)
    },
    onOk (event) {
      if (this.copyToUsers && this.copyToUsers.length) {
        this.$bvModal.show('confirm-copy')
      } else {
        toast.warning('Nenhum usuário selecionado')
        event.preventDefault()
      }
    },
    onOkConfirm () {
      const contratoContaCopy = {
        acessos: this.selectedContracts.options.map(c => c.value),
        contas: this.copyToUsers.map(c => c.value)
      }
      console.log(contratoContaCopy)
      if (this.copyType === 'inclusive') {
        this.saveUserAccessInclusiveCopy(contratoContaCopy)
      } else if (this.copyType === 'exclusive') {
        this.saveUserAccessExclusiveCopy(contratoContaCopy)
      }
    },
    onCancelConfirm () {
      this.$bvModal.show('copy-modal')
    },
    saveUserAccessInclusiveCopy (contratoContaCopy) {
      loading.push()
      AccountContractsRepository.SaveAccessInclusiveCopy(contratoContaCopy)
        .then(response => {
          if (response.status !== 200) {
            loading.close()
            toast.error(this.$lang.Common.CouldNotLoadRegister)
            return
          }
          this.selectedUserCopy = null
          this.copyToUsers = []
          toast.success(this.$lang.Common.Alerts.Success)
          loading.close()
        }).catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
    },
    saveUserAccessExclusiveCopy (contratoContaCopy) {
      loading.push()
      AccountContractsRepository.SaveAccessExclusiveCopy(contratoContaCopy)
        .then(response => {
          if (response.status !== 200) {
            loading.close()
            toast.error(this.$lang.Common.CouldNotLoadRegister)
            return
          }
          this.selectedUserCopy = null
          this.copyToUsers = []
          toast.success(this.$lang.Common.Alerts.Success)
          loading.close()
        }).catch(err => {
          console.log(err)
          toast.error(this.$lang.Common.Alerts.Error)
        })
    },
    processVisibleAvailableContracts (value) {
      if (!value) {
        this.availableContracts.visibleOptions = this.availableContracts.options
        return
      }

      const values = value.trim().split(' ')
      let allAvailable = this.contracts

      values.forEach(v => {
        allAvailable = allAvailable.filter(c => !v || c.name.toLowerCase().includes(v.toLowerCase()))
      })

      if (allAvailable.length) {
        this.availableContracts.visibleOptions = allAvailable
          .filter(c => !this.selectedContracts.options.map(c => c.value).includes(c.id))
          .map(c => { return { value: c.id, text: c.name } })
          .sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      } else {
        this.availableContracts.visibleOptions = []
      }
    },
    processVisibleAvailableUsers (value) {
      if (!value) {
        this.availableUsers.visibleOptions = this.availableUsers.options
        return
      }

      const values = value.trim().split(' ')
      let allAvailable = this.users

      values.forEach(v => {
        allAvailable = allAvailable.filter(c => !v || c.text.toLowerCase().includes(v.toLowerCase()))
      })

      if (allAvailable.length) {
        this.availableUsers.visibleOptions = allAvailable
          .filter(c => !this.selectedUsers.options.map(c => c.value).includes(c.id))
          .map(c => { return { value: c.value, text: c.text } })
          .sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      } else {
        this.availableUsers.visibleOptions = []
      }
    },
    processVisibleSelectedContracts (value) {
      if (!value) {
        this.selectedContracts.visibleOptions = this.selectedContracts.options
        return
      }

      const values = value.trim().split(' ')
      let allSelected = this.contracts

      values.forEach(v => {
        allSelected = allSelected.filter(c => !v || c.name.toLowerCase().includes(v.toLowerCase()))
      })

      if (allSelected.length) {
        this.selectedContracts.visibleOptions = allSelected
          .filter(c => !this.availableContracts.options.map(c => c.value).includes(c.value))
          .map(c => { return { value: c.id, text: c.name } })
          .sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      } else {
        this.selectedContracts.visibleOptions = []
      }
    },
    processVisibleSelectedUsers (value) {
      if (!value) {
        this.selectedUsers.visibleOptions = this.selectedUsers.options
        return
      }

      const values = value.trim().split(' ')
      let allSelected = this.users

      values.forEach(v => {
        allSelected = allSelected.filter(c => !v || c.text.toLowerCase().includes(v.toLowerCase()))
      })

      if (allSelected.length) {
        this.selectedUsers.visibleOptions = allSelected
          .filter(c => !this.availableUsers.options.map(c => c.value).includes(c.value))
          .map(c => { return { value: c.value, text: c.text } })
          .sort((a, b) => a.text < b.text ? -1 : a.text > b.text ? 1 : 0)
      } else {
        this.selectedUsers.visibleOptions = []
      }
    }
  },
  watch: {
    keyWord: function (value) {
      this.keyFilter.name = value
      if (this.selectedUser) this.processVisibleAvailableContracts(value)
      if (this.selectedContract) this.processVisibleAvailableUsers(value)
    },
    keyWordSelected: function (value) {
      if (this.selectedUser) this.processVisibleSelectedContracts(value)
      if (this.selectedContract) this.processVisibleSelectedUsers(value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/pci/contracts/contracts.js